import deepFreeze from './utils/object/deepFreeze'

export default deepFreeze({
  easing: {
    default: [0.7, 0, 0.3, 1],
  },
})

